__turbopack_context__.v({
  "container": "zv188G_container",
  "label": "zv188G_label",
  "labelRow": "zv188G_labelRow",
  "noteIcon": "zv188G_noteIcon",
  "optionCard": "zv188G_optionCard",
  "optionCardSelected": "zv188G_optionCardSelected",
  "optionDescription": "zv188G_optionDescription",
  "optionGroup": "zv188G_optionGroup",
  "optionHeader": "zv188G_optionHeader",
  "optionIcon": "zv188G_optionIcon",
  "optionIconSvg": "zv188G_optionIconSvg",
  "optionTitle": "zv188G_optionTitle",
  "optionsGrid": "zv188G_optionsGrid",
});
